// src/pages/Terminos.jsx
import React from "react";
import { Helmet } from "react-helmet";
const Terminos = () => {
  return (
    <div className="terminos-container">
      <Helmet>
        <title>ABX Shipping - Términos y condiciones</title>
      </Helmet>
      <iframe
        src="/assets/archivos/POLITICAS Y CONDICIONES DE SERVICIO - AIRBOX SHIPPING.pdf"
        title="Términos y Condiciones"
        className="pdf-viewer"
        frameBorder="0"
      ></iframe>
    </div>
  );
};

export default Terminos;
